// IE 2026 10 01 / ODOO-341407 (отчёт ie-demo7 / Андрея, Demo 6 dev02: после uk→en и F5 язык возвращался к uk): явный язык USER с бэка
// (adoptServerLanguage) считается выбором «с другого устройства» и перебивает выбор этого браузера. Если выбор НЕ дошёл до бэка — роль
// «только чтение» не шлёт user_settings_save (ODOO-342781), либо сохранение не удалось (сеть / ошибка бэка) — бэк продолжает отдавать старый
// язык, и страница откатывается на него при каждой перезагрузке.
// Правило: выбор пользователя в меню ПОМЕЧАЕТСЯ локально («ожидает сохранения»: localStorage, ключ на базу + пользователя) до подтверждённого
// сохранения на бэке; пока метка стоит и совпадает с языком страницы (локальный выбор в силе), язык с бэка не принимается. Сохранение
// удалось — метка снимается, и последующий выбор на другом устройстве снова доезжает сюда; бэк уже отдаёт тот же язык — метка снимается.
// Чистая логика без зависимостей (хранилище передаётся аргументом) — tests/unit/langPending.test.mjs
// IE 2026 10 07 / ODOO-341407 (слияние с ODOO-345045 — слова Игоря «язык берется при перезагрузке из пользователя, а не из куки»; роль «только чтение» и
// неудачное сохранение предупреждаются «It will reset on the next reload»): метка держится ТОЛЬКО пока сохранение в полёте — read-only её не ставит,
// любой ответ user_settings_save снимает, без ответа она истекает через LANG_PENDING_MAX_AGE_MS. Защищён случай «выбрал и сразу F5, ответ не успел»
export const LANG_PENDING_PREFIX = 'fe.i18n.langPending.'
export const LANG_PENDING_MAX_AGE_MS = 60000   // IE 2026 10 07 / ODOO-341407

const _s = (v) => (v === undefined || v === null ? '' : String(v))
// ключ: база + пользователь (id базы — user.database.dbid, пользователь — email, иначе id); без пользователя ключа нет
export function langPendingKey(user) {
    if (!user || typeof user !== 'object') return ''
    const who = _s(user.email || user.id).trim().toLowerCase()
    if (!who) return ''
    const db = user.database
    const dbid = _s(db && typeof db === 'object' ? db.dbid : db).trim()
    return `${LANG_PENDING_PREFIX}${dbid}|${who}`
}
function _store(storage) {
    if (storage) return storage
    try { return typeof localStorage !== 'undefined' ? localStorage : null } catch (e) { return null }   // приватный режим: доступ может бросить
}
// язык метки ('' — метки нет / не читается); IE 2026 10 07 / ODOO-341407: maxAgeMs > 0 — метка старше срока (или без отметки времени) не действует
export function readLangPending(key, storage = null, { maxAgeMs = 0, now = Date.now() } = {}) {
    if (!key) return ''
    try {
        const st = _store(storage)
        const raw = st && st.getItem(key)
        if (!raw) return ''
        const v = JSON.parse(raw)
        if (maxAgeMs > 0 && !(v && typeof v.at === 'number' && now - v.at <= maxAgeMs)) return ''   // IE 2026 10 07 / ODOO-341407
        return v && typeof v.lang === 'string' ? v.lang : ''
    } catch (e) { return '' }
}
export function writeLangPending(key, lang, storage = null, now = Date.now()) {
    if (!key || !lang) return false
    try {
        const st = _store(storage)
        if (!st) return false
        st.setItem(key, JSON.stringify({ lang, at: now }))
        return true
    } catch (e) { return false }
}
// снять метку; lang задан — только если метка именно этого языка (ответ СТАРОГО сохранения не должен снять метку более позднего выбора)
export function clearLangPending(key, lang = '', storage = null) {
    if (!key) return false
    try {
        const st = _store(storage)
        if (!st) return false
        if (lang && readLangPending(key, st) !== lang) return false
        st.removeItem(key)
        return true
    } catch (e) { return false }
}
// ответ user_settings_save: сохранение удалось — status 'ok' (бэк возвращает {status:'ok', language}), сохранённый язык, если назван, — выбранный;
// ошибка бэка (status 'error', error) и ответ неизвестной команды не считаются; сетевая ошибка колбэк не вызывает вовсе
export function langSaveOk(answer, lang = '') {
    if (!answer || typeof answer !== 'object' || answer.error) return false
    if (_s(answer.status).toLowerCase() !== 'ok') return false
    return !lang || answer.language === undefined || answer.language === lang
}
// решение при явном языке USER с бэка: 'block' — локальный выбор в силе, язык с бэка не принимать; 'clear' — бэк уже отдаёт тот же язык,
// метку снять; '' — метки нет / она устарела (язык страницы другой: выбор сброшен или поменян иначе) — прежнее поведение
export function langPendingDecision(pending, serverLang, pageLang) {
    if (!pending) return ''
    if (pending === serverLang) return 'clear'
    return pending === pageLang ? 'block' : ''
}
